import React, { useState } from 'react';
import Navigation from '../../../components/Navigation/Navigation';
import './Contact.css';
import FrontendFooter from '../../../components/Layout/FrontendFooter';
import axios from 'axios';
import { API_ENDPOINTS } from '../../../config/api';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    mobile: '',
    message: ''
  });
  const [isLoading, setIsLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'info'
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'mobile') {
      // Only allow numbers and limit to 10 digits
      const sanitizedValue = value.replace(/[^0-9]/g, '').slice(0, 10);
      setFormData(prevState => ({
        ...prevState,
        [name]: sanitizedValue
      }));
    } else {
      setFormData(prevState => ({
        ...prevState,
        [name]: value
      }));
    }
  };

  const validateForm = () => {
    if (!formData.name.trim()) {
      setSnackbar({
        open: true,
        message: "Please enter your name",
        severity: "error"
      });
      return false;
    }
    if (!formData.email.trim()) {
      setSnackbar({
        open: true,
        message: "Please enter your email",
        severity: "error"
      });
      return false;
    }
    if (!/\S+@\S+\.\S+/.test(formData.email)) {
      setSnackbar({
        open: true,
        message: "Please enter a valid email address",
        severity: "error"
      });
      return false;
    }
    if (!formData.mobile.trim()) {
      setSnackbar({
        open: true,
        message: "Please enter your mobile number",
        severity: "error"
      });
      return false;
    }
    // Updated validation for exactly 10 digits
    if (!/^[0-9]{10}$/.test(formData.mobile.trim())) {
      setSnackbar({
        open: true,
        message: "Please enter a valid 10-digit mobile number",
        severity: "error"
      });
      return false;
    }
    if (!formData.message.trim()) {
      setSnackbar({
        open: true,
        message: "Please enter your message",
        severity: "error"
      });
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }

    setIsLoading(true);
    const transformedData = {
      name: formData.name.trim(),
      email: formData.email.trim(),
      mobile: formData.mobile.trim(),
      message: formData.message.trim()
    };

    try {
      await axios.post(API_ENDPOINTS.SEND_EMAIL, transformedData);
      setSnackbar({
        open: true,
        message: "Thank you for your message! We will get back to you soon.",
        severity: "success"
      });
      setFormData({
        name: "",
        email: "",
        mobile: "",
        message: ""
      });
    } catch (error) {
      console.error('Contact form submission error:', error);
      setSnackbar({
        open: true,
        message: error.response?.data?.message || "Error submitting enquiry. Please try again.",
        severity: "error"
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="app-container">
      <Navigation />
      <section className="inner-banner text-white">
        <div className='home-container'>
          <h1 className='page-title'>Contact Us</h1>
          <p>Get in touch with our team</p>
        </div>
      </section>
      <main className="contact-container">
        <div className="contact-content">
          <div className="contact-info">
            <div className="info-card">
              <div className="info-icon">📍</div>
              <h3>Our Location</h3>
              <p>Green City, Near Apparel Export Park,
              Vadlapudi post, Visakhapatnam – 530 046,
              Andhra Pradesh</p>
            </div>
            <div className="info-card">
              <div className="info-icon">📞</div>
              <h3>Phone Number</h3>
              <p>91 7036 300 300</p>
              <p>Mon-Fri, 9am-6pm</p>
            </div>
            <div className="info-card">
              <div className="info-icon">✉️</div>
              <h3>Email Address</h3>
              <p>info@steelbuddy.com</p>
            </div>
          </div>

          <form className="contact-form" onSubmit={handleSubmit}>
            <h2>Send us a Message</h2>
            <div className="form-group">
              <label htmlFor="name">Name</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                disabled={isLoading}
                placeholder="Enter your name"
              />
            </div>
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                disabled={isLoading}
                placeholder="Enter your email"
              />
            </div>
            <div className="form-group">
              <label htmlFor="mobile">Mobile Number</label>
              <input
                type="tel"
                id="mobile"
                name="mobile"
                value={formData.mobile}
                onChange={handleChange}
                required
                disabled={isLoading}
                placeholder="Enter 10-digit mobile number"
                pattern="[0-9]*"
                inputMode="numeric"
                maxLength="10"
              />
            </div>
            <div className="form-group">
              <label htmlFor="message">Message</label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                required
                rows="5"
                disabled={isLoading}
                placeholder="Enter your message"
              ></textarea>
            </div>
            <button type="submit" className="submit-button" disabled={isLoading}>
              {isLoading ? 'Sending...' : 'Send Message'}
            </button>
            {snackbar.open && (
          <div className={`message-container ${snackbar.severity}`}>
            <div className="message-icon">
              {snackbar.severity === 'success' ? '✓' : '⚠️'}
            </div>
            <div className="message-content">
              <h4>{snackbar.severity === 'success' ? 'Success!' : 'Error!'}</h4>
              <p>{snackbar.message}</p>
            </div>
          </div>
        )}
          </form>
        </div>
      
      </main>
      <FrontendFooter/>
    </div>
  );
};

export default Contact; 